import script from "./LocalizationList.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocalizationList.vue?vue&type=script&lang=ts&setup=true"

import "./LocalizationList.vue?vue&type=style&index=0&id=c1f61798&scoped=true&lang=css"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f61798"]])

export default __exports__